// Packages
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const StyledBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  marginLeft: "50px",
  marginTop: "20px",
  gap: 10,
}));